import _ from 'lodash';
import { PRELOAD_APP_MEDIA_TIMEOUT_MS } from '../api';
import Icons from '../components/Icon/Icons';
import Illustrations from '../components/Illustration/Illustrations';
import { delay } from '../helpers';

const loadImage = (url: string) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = resolve;
    img.onerror = resolve;
    img.src = url;
  });
};

const loadImagesByUrls = async (urls: string[]) =>
  new Promise((resolve, reject) =>
    Promise.all(_.map(urls, loadImage)).then(resolve).catch(reject),
  );

export const preloadAppMedia = async () => {
  const iconsUrls = _.values(Icons);
  const illustrationsUrls = _.values(Illustrations);

  const appMediaUrls = _.concat(iconsUrls, illustrationsUrls);

  await Promise.race([
    loadImagesByUrls(appMediaUrls),
    delay(PRELOAD_APP_MEDIA_TIMEOUT_MS),
  ]);
};
